import dictlist from '@/api/sysmanagement/dictlist';
import locker from '@/util/locker';

import * as types from '../mutation-types';

import _ from 'lodash';

const state = {
  dictMap: {},
  lockerManager: {},
  afterMeetingDays: [],
};

const getters = {
  dictMap: state => state.dictMap,
  afterMeetingDays: state => state.afterMeetingDays,
};

const mutations = {
  [types.SET_DICT_ITEM](state, {
    dictMap
  }) {
    state.dictMap = _.assign({}, state.dictMap, dictMap);
  },
};

const actions = {
  getDictItemsByCode({
    commit,
    dispatch
  }, code) {
    const lockerKey = 'dict:' + code;
    while (locker.getLocker(lockerKey)) {
      return;
    }
    return new Promise((resolve, reject) => {
      const { dictMap } = state;
      if (dictMap[code]) {
        locker.releaseLocker(lockerKey);
        resolve(dictMap[code].res);
      } else {
        dictlist.getDictItemsByCode(code)
          .then((res) => {
            locker.releaseLocker(lockerKey);
            if (res.success) {
              const newMap = {};
              newMap[code] = {
                name: code,
                options: res.result,
                res: res
              };
              commit(types.SET_DICT_ITEM, {
                dictMap: newMap
              });
            }
            resolve(res);
          }, (err) => {
            console.error('err', err);
            locker.releaseLocker(lockerKey);
          });
      }
    });

  },

  getDictProvinceList({
    commit,
    dispatch
  }, code) {
    const lockerKey = 'dict:province';
    while (locker.getLocker(lockerKey)) {
      return;
    }
    return new Promise((resolve, reject) => {
      const { dictMap } = state;
      if (dictMap[code]) {
        locker.releaseLocker(lockerKey);
        resolve(dictMap[code].res);
      } else {
        dictlist.getProvinceList(code)
          .then((res) => {
            locker.releaseLocker(lockerKey);
            if (res.success) {
              // reset result key to dict key
              res.result.map((option) => {
                option.value = option.id;
                option.text = option.name;
                option.textEn = option.nameEn;
              });
              const newMap = {};
              newMap.province = {
                name: code,
                options: res.result,
                res: res
              };
              commit(types.SET_DICT_ITEM, {
                dictMap: newMap
              });
            }
            resolve(res);
          }, (err) => {
            console.error('err', err);
            locker.releaseLocker(lockerKey);
          });
      }
    });

  },

  getDictAribaCategoryList({
    commit,
    dispatch
  }, code) {
    const lockerKey = 'dict:airba_category';
    while (locker.getLocker(lockerKey)) {
      return;
    }
    return new Promise((resolve, reject) => {
      const { dictMap } = state;
      if (dictMap[code]) {
        locker.releaseLocker(lockerKey);
        resolve(dictMap[code].res);
      } else {
        dictlist.getAribaCategoryList(code)
          .then((res) => {
            locker.releaseLocker(lockerKey);
            if (res.success) {
              // reset result key to dict key
              res.result.map((option) => {
                option.value = option.commodityCode;
                option.text = option.categoryName;
                option.textEn = option.categoryName;
              });
              const newMap = {};
              newMap.airba_category = {
                name: code,
                options: res.result,
                res: res
              };
              commit(types.SET_DICT_ITEM, {
                dictMap: newMap
              });
            }
            resolve(res);
          }, (err) => {
            console.error('err', err);
            locker.releaseLocker(lockerKey);
          });
      }
    });
  }

};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/overall.js